'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerFootnote = renderWithRef('BannerFootnote', null, (e, n)=>{
    let { children: t } = e;
    return jsx(RenderComp, {
        root: "p",
        forwardedRef: n,
        classNames: [
            'swan-banner-footnote'
        ],
        props: e,
        children: t
    });
});

export { BannerFootnote };
